export const costToFrench = (value, precision = 2) => {
  const number = Number(value);
  if (isNaN(number)) return value;

  return number.toLocaleString("fr-FR", {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
};

export const getPhonePrefix = (phoneNumber) => {
  const phone = phoneNumber.replace(/\s+/g, " ").slice(0, -9);
  const match = phone.match(/^(?:\+|00)(\d{1,3})/);
  return match ? `+${match[1]}` : "+33";
};